import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-timeout-modal',
    templateUrl: './timeout-modal.component.html',
    styleUrls: ['./timeout-modal.component.css'],
    standalone: false
})
export class TimeoutModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  refreshClicked() {
    this.activeModal.close('refresh');
  }

  logoutClicked() {
    this.activeModal.close('logout');
  }
}
